"use client";

import { ChevronRight } from "lucide-react";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { Fragment, type ReactElement } from "react";
import { useHelpHref } from "./help-link-base";

export type HelpCrumb = {
  readonly label: string;
  readonly href: string;
};

/** "Alle Themen › … › current": every step but the last is a link. */
export function HelpBreadcrumb({
  org_slug,
  items,
  current,
}: {
  readonly org_slug: string;
  readonly items: readonly HelpCrumb[];
  readonly current: string;
}): ReactElement {
  const t = useTranslations("public.helpBreadcrumb");
  const helpHref = useHelpHref(org_slug);
  const links: readonly HelpCrumb[] = [
    {
      label: t("alleThemen"),
      href: helpHref({ kind: "center" }),
    },
    ...items,
  ];
  return (
    <nav
      aria-label={t("pfad")}
      className="mb-6 flex flex-wrap items-center gap-1 text-[12.5px] text-primary/50"
    >
      {links.map((item, index) => (
        <Fragment key={item.href}>
          {index > 0 ? (
            <ChevronRight
              aria-hidden
              className="h-3 w-3 shrink-0 text-primary/30"
            />
          ) : null}
          <Link
            href={item.href}
            prefetch={false}
            className="max-w-[22ch] truncate hover:text-primary/80"
          >
            {item.label}
          </Link>
        </Fragment>
      ))}
      <ChevronRight aria-hidden className="h-3 w-3 shrink-0 text-primary/30" />
      <span className="max-w-[22ch] truncate text-primary/75">{current}</span>
    </nav>
  );
}
